import { type RouteRecordRaw } from 'vue-router'

const invoicesRoutes: Array<RouteRecordRaw> = [
  {
    path: '/purchasing/invoices',
    name: 'invoices.index',
    component: () => import('@/modules/purchasing/invoices/views/InvoicesIndex.vue'),
    meta: {
      pageTitle: 'Invoices Index',
      breadcrumbs: ['Invoices']
    }
  },
  {
    path: '/purchasing/invoices/:id',
    name: 'invoices.show',
    component: () => import('@/modules/purchasing/invoices/views/InvoicesShow.vue'),
    meta: {
      pageTitle: 'Invoice Show',
      breadcrumbs: ['Invoices']
    }
  },
  {
    path: '/purchasing/invoices/create',
    name: 'invoices.create',
    component: () => import('@/modules/purchasing/invoices/views/InvoicesEdit.vue'),
    meta: {
      pageTitle: 'Invoice Create',
      breadcrumbs: ['Invoices']
    }
  },
  {
    path: '/purchasing/invoices/:id/edit',
    name: 'invoices.edit',
    component: () => import('@/modules/purchasing/invoices/views/InvoicesEdit.vue'),
    meta: {
      pageTitle: 'Invoice Edit',
      breadcrumbs: ['Invoices']
    },
    props: true
  }
]

export default invoicesRoutes
